/*!
 * Патчи совместимости jQuery 3.x с legacy-кодом B2B.
 */
(function ($) {
    'use strict';

    if (!$) {
        return;
    }

    // $.browser удалён в jQuery 1.9+/3.x; legacy-плагины и старый код B2B всё ещё обращаются к нему.
    if (!$.browser) {
        var ua = navigator.userAgent;
        var msie = /MSIE |Trident\//.test(ua);
        var mozilla = /Firefox\//.test(ua);
        var safari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua);
        var opera = /OPR\/|Opera\//.test(ua);
        var versionMatch = msie ? (ua.match(/MSIE ([\d.]+)/) || ua.match(/rv:([\d.]+)/))
            : mozilla ? ua.match(/Firefox\/([\d.]+)/)
            : opera ? (ua.match(/OPR\/([\d.]+)/) || ua.match(/Opera\/([\d.]+)/))
            : safari ? ua.match(/Version\/([\d.]+)/)
            : null;

        $.browser = {
            msie: msie,
            mozilla: mozilla,
            safari: safari,
            opera: opera,
            version: versionMatch ? versionMatch[1] : '0'
        };
    }

    if (!$.ajaxSettings || $.ajaxSettings._b2bJqueryCompat) {
        return;
    }

    // jQuery 1.9+ отклоняет пустое тело при dataType: json; ASP.NET Json(null) отдаёт пустую строку.
    $.ajaxSettings.converters['text json'] = function (text) {
        return text === '' ? null : JSON.parse(text);
    };

    // DevExtreme/jQuery cache могут содержать нестроковые ключи; jQuery.camelCase() падает на .replace().
    if ($.camelCase && !$.camelCase._b2bAngularCompat) {
        var originalCamelCase = $.camelCase;

        $.camelCase = function (value) {
            if (typeof value !== 'string') {
                return value == null ? '' : String(value);
            }

            return originalCamelCase(value);
        };

        $.camelCase._b2bAngularCompat = true;
    }

    // AngularJS replaceWith копирует jQuery.data() между узлами с нестроковыми ключами.
    // Патчим только $.fn.data: DevExtreme хранит виджеты через jQuery.data(element, key),
    // статический $.data трогать нельзя.
    if ($.fn && $.fn.data && !$.fn.data._b2bAngularCompat) {
        var originalFnData = $.fn.data;

        $.fn.data = function (key, value) {
            if (arguments.length === 1 && $.isPlainObject(key)) {
                var filtered = {};

                $.each(key, function (k, v) {
                    if (typeof k === 'string') {
                        filtered[k] = v;
                    }
                });

                return originalFnData.call(this, filtered);
            }

            if (arguments.length >= 1 && typeof key !== 'string') {
                return arguments.length === 1 ? undefined : this;
            }

            return originalFnData.apply(this, arguments);
        };

        $.fn.data._b2bAngularCompat = true;
    }

    $.ajaxSettings._b2bJqueryCompat = true;
})(window.jQuery);
